import React from 'react';
import PropTypes from 'prop-types';
import {Container, Image, Grid} from 'semantic-ui-react';
import {makeDBOriginalImageUrl, formatDate} from "utils/DBUtils";

/**
 * Image Card
 * @param props
 * @constructor
 */
const ImageCard = (props) => (
    <Container>
        <h3 onClick={() => this.props.startEditImage(props)}>{props.name}</h3>
        <Image src={makeDBOriginalImageUrl(props.id)}/>
        <Grid columns={2}>
            <Grid.Row>
                <Grid.Column>
                    {formatDate(props._created)}
                </Grid.Column>
                <Grid.Column>
                    More
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </Container>
);

ImageCard.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    _created: PropTypes.number.isRequired
};

export default ImageCard;



// WEBPACK FOOTER //
// ./public/components/images/ImageCard.jsx